// combination of token -> roles
var tokenRoleMap = {
	'token_polpp' : require('./fake_tokens/token_analis.json'),
	'token_admin' : require('./fake_tokens/token_admin.json'),
	'token_analis' : require('./fake_tokens/token_analis.json'),
	'token_polpp' : require('./fake_tokens/token_polpp.json'),
	'token_polpp2' : require('./fake_tokens/token_polpp2.json'),
	'token_kanwil' : require('./fake_tokens/token_kanwil.json'),
	'token_polpp_jaktim' : require('./fake_tokens/token_polpp_jaktim.json'),
	'token_kppbc' : require('./fake_tokens/token_kppbc.json'),
	'token_kppbc2' : require('./fake_tokens/token_kppbc2.json'),
	'token_kppbc3' : require('./fake_tokens/token_kppbc3.json'),
	'token_kppbc4' : require('./fake_tokens/token_kppbc4.json'),
}

/**
 * Generate usable user info based on fake data above
 */
function getFakeUser(token) {
	var user = tokenRoleMap[token]
	// user.roleinfo.siroleg = tokenRoleMap[token] || []

	return user
}

export {
	getFakeUser
}



// WEBPACK FOOTER //
// ./src/router/fakeUser.js